// Discover Range — filterable grid + product modal.
// Filtering toggles cards by data-cat; the modal clones each card's hidden
// <template> into a shared dialog (keeps all rendering in Liquid).
if (!customElements.get("range-product-grid")) {
  customElements.define(
    "range-product-grid",
    class RangeProductGrid extends HTMLElement {
      constructor() {
        super();
        this.chips = this.querySelectorAll("[data-filter-chip]");
        this.cards = this.querySelectorAll("[data-range-card]");
        this.countEl = this.querySelector("[data-range-count]");
        this.filterBar = this.querySelector(".discover-grid__filter-bar");
        this.overlay = this.querySelector("[data-range-modal-overlay]");
        this.box = this.querySelector("[data-range-modal-box]");
        this.content = this.querySelector("[data-range-modal-content]");
        this.closeBtn = this.querySelector("[data-range-modal-close]");
        this.lastFocused = null;

        // Bound handlers so add/removeEventListener match.
        this.onChipClick = this.onChipClick.bind(this);
        this.onCardClick = this.onCardClick.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setFilterOffset = this.setFilterOffset.bind(this);
      }

      connectedCallback() {
        this.chips.forEach((chip) => chip.addEventListener("click", this.onChipClick));
        this.cards.forEach((card) => card.addEventListener("click", this.onCardClick));
        this.closeBtn?.addEventListener("click", this.closeModal);
        this.overlay?.addEventListener("click", this.onOverlayClick);
        this.setFilterOffset();
        window.addEventListener("resize", this.setFilterOffset);
      }

      disconnectedCallback() {
        this.chips.forEach((chip) => chip.removeEventListener("click", this.onChipClick));
        this.cards.forEach((card) => card.removeEventListener("click", this.onCardClick));
        this.closeBtn?.removeEventListener("click", this.closeModal);
        this.overlay?.removeEventListener("click", this.onOverlayClick);
        window.removeEventListener("resize", this.setFilterOffset);
        document.removeEventListener("keydown", this.onKeydown);
        document.documentElement.classList.remove("overflow-hidden");
      }

      // Stick the filter bar just below the sticky site header.
      setFilterOffset() {
        if (!this.filterBar) return;
        const header = document.querySelector(".section-header");
        const top = header ? header.offsetHeight : 0;
        this.filterBar.style.setProperty("--filter-top", `${top}px`);
      }

      /* ---- Filtering ---- */
      onChipClick(e) {
        const chip = e.currentTarget;
        const cat = chip.dataset.cat;

        this.chips.forEach((c) => {
          const active = c === chip;
          c.classList.toggle("is-active", active);
          c.setAttribute("aria-pressed", active ? "true" : "false");
        });

        let visible = 0;
        this.cards.forEach((card) => {
                    const show = cat === "all" || (card.dataset.catHandles || card.dataset.cat).split(" ").includes(cat);
          card.classList.toggle("hidden", !show);
          if (show) visible += 1;
        });

        if (this.countEl) {
          this.countEl.textContent = `${visible} ${visible === 1 ? "product" : "products"}`;
        }
      }

      /* ---- Modal ---- */
      onCardClick(e) {
        const card = e.currentTarget;
        const tpl = card.querySelector("[data-range-modal]");
        if (!tpl) return;
        this.openModal(tpl);
      }

      openModal(tpl) {
        this.lastFocused = document.activeElement;
        this.content.replaceChildren(tpl.content.cloneNode(true));
        this.overlay.hidden = false;
        // Next frame so the transition runs from the hidden state.
        requestAnimationFrame(() => this.overlay.classList.add("is-open"));
        document.documentElement.classList.add("overflow-hidden");
        document.addEventListener("keydown", this.onKeydown);
        this.box.focus();
        
      }

      closeModal() {
        this.overlay.classList.remove("is-open");
        document.documentElement.classList.remove("overflow-hidden");
        document.removeEventListener("keydown", this.onKeydown);
        const hide = () => {
          this.overlay.hidden = true;
          this.content.replaceChildren();
        };
        // Wait for the fade-out unless reduced motion is preferred.
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          hide();
        } else {
          this.overlay.addEventListener("transitionend", hide, { once: true });
        }
        this.lastFocused?.focus();
      }

      onOverlayClick(e) {
        if (e.target === this.overlay) this.closeModal();
      }

      onKeydown(e) {
        if (e.key === "Escape") {
          this.closeModal();
        } else if (e.key === "Tab") {
          this.trapFocus(e);
        }
      }

      trapFocus(e) {
        const focusable = this.box.querySelectorAll(
          'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  );
}
